module.exports = __webpack_public_path__ + "static/media/bank.4c2edab3.png";